import _slicedToArray from "/codebuild/output/src2317851137/src/gatsby-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
export var getWindowSize = function getWindowSize() {
  if (typeof window === 'undefined') {
    return {
      innerWidth: 0,
      outerWidth: 0
    };
  }

  var _window = window,
      innerWidth = _window.innerWidth,
      outerWidth = _window.outerWidth;
  return {
    innerWidth: innerWidth,
    outerWidth: outerWidth
  };
};

var useWindowSize = function useWindowSize() {
  var _useState = useState(getWindowSize()),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      setWindowSize(getWindowSize());
    };

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};

export default useWindowSize;